import React from "react";
import { createPortal } from "react-dom";

const StepSuccessModal = ({
  isOpen,
  onClose,
  onAddAnother,
  onNavigate,
  message = "Saved successfully!",
  nextButtonText = "Go to Next Step",
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="mb-0">{message}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body text-center">
            <i className="fa fa-circle-check fs-3 text-success mb-2"></i>
            <p className="mb-0">
              Would you like to add another item, or <br />
              continue to the next section?
            </p>
          </div>
          <div className="modal-footer flex-center">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={onAddAnother}
            >
              Add Another
            </button>
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={onNavigate}
            >
              {nextButtonText}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default StepSuccessModal;
